export default __webpack_public_path__ + "static/media/whatissuki.8fa0825b.png";